import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import TopHeader from "../Dashoboard/TopHeader";
import AddIcon from "@mui/icons-material/Add";
import {
  useLazyTipsDeleteQuery,
  useLazyTipsListQuery,
  useLazyTipsStatusQuery,
  useTipsCreateMutation,
  useTipsUpdateMutation,
} from "../../redux/api/api";
import { editIcon } from "../../assets/img";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";
import Swal from "sweetalert2";
import CloseIcon from "@mui/icons-material/Close";
import { MdOutlineDeleteForever } from "react-icons/md";

const TipsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [update, setUpdate] = useState({});
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [overAllCount, setOverALlCount] = useState(1);
  const [pagination, setPagonation] = useState({});
  const [search, setSearch] = useState("");
  const [row, setRow] = useState(10);
  const [btn, setBtn] = useState(false);
  const [tipsAmount, setTipsAmount] = useState("");
  const [tipsAmountErr, setTipsAmountErr] = useState(false);

  // RTK QUERY
  const [listApi] = useLazyTipsListQuery();
  const [statusApi] = useLazyTipsStatusQuery();
  const [addApi] = useTipsCreateMutation();
  const [editApi] = useTipsUpdateMutation();
  const [tipsDeleteApi] = useLazyTipsDeleteQuery();

  const getList = (search_value, row_value) => {
    let params = `?page=${page}`;

    if (search_value) {
      params += `&search=${search_value}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    setSearch(search_value);
    setRow(row_value);
    dispatch(saveLoader(true));
    listApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setList(res?.tips);
        setOverALlCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonation(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    getList(search, row);
  }, [page]);

  const handlePageChange = (selectedObject) => {
    setPage(selectedObject.selected + 1);
  };

  const statusChange = (id) => {
    dispatch(saveLoader(true));
    setBtn(true);
    statusApi(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success") {
          getList(search, row);
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err");
      });
  };

  const submitHandler = () => {
    if (tipsAmount?.length == 0) {
      setTipsAmount(true);
    } else {
      let formdata = new FormData();
      formdata.append("tip_amount", tipsAmount);
      setBtn(true);
      dispatch(saveLoader(true));
      if (update?.id) {
        editApi({ payload: formdata, id: update?.id })
          .unwrap()
          .then((res) => {
            closePopup();
            setBtn(false);
            dispatch(saveLoader(false));
            getList();
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      } else {
        addApi(formdata)
          .unwrap()
          .then((res) => {
            closePopup();
            setBtn(false);
            dispatch(saveLoader(false));
            getList();
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      }
    }
  };

  const closePopup = () => {
    setModal(false);
    setUpdate("");
    setBtn(false);
    setTipsAmount("");
    setTipsAmountErr(false);
  };

  const getView = (item) => {
    setUpdate(item);
    setTipsAmount(item?.tip_amount);
    setModal(true);
  };

  const deleteApi = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reject it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(saveLoader(true));
        setBtn(true);
        tipsDeleteApi(id)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                title: "Reject!",
                text: "Your file has been Rejected.",
                icon: "success",
              });
              closePopup();
              getList();
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err", err);
          });
      }
    });
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"tips"} />
      <div className="block block-rounded ">
        <div className="block-content">
          <Row>
            <Col md={6}>
              <label className="table-labels f1">
                Total Count : {list?.length}
              </label>
            </Col>
            <Col sm={6} md={6}>
              <div className="d-flex ac-je block-header add-btn">
                <button className="f1 d-flex" onClick={() => setModal(true)}>
                  <AddIcon />
                  Add Tips
                </button>
              </div>
            </Col>
          </Row>
          {/* <div className="d-flex ac-jb">
            <div className="col-md-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) => getList(search, e.target.value)}
                value={row}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            <div className="mb-2">
              <input
                className="form-control bg-white"
                placeholder="Search..."
                style={{ width: "300px" }}
                onChange={(e) => getList(e.target.value, row)}
                value={search}
              />
            </div>
          </div> */}
          <div className="table-custom-design overflow-scroll">
            <table>
              <thead>
                <tr className="text-capitalize">
                  <th>S.NO</th>
                  <th>Tip Amount</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list?.map((item, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{ind + 1}</td>
                      <td>{item?.tip_amount}</td>
                      <td>
                        <button
                          className={`${
                            item?.status == 1 ? "btn-success" : "btn-danger"
                          } px-2 py-1 rounded-1 border-0 text-white`}
                          onClick={() => statusChange(item?.id)}
                          disabled={btn}
                        >
                          {item?.status == 1 ? "Active" : "Deactive"}
                        </button>
                      </td>
                      <td>
                        <div className="d-flex ac-jc gap-2">
                          <button
                            className="cust-btn"
                            onClick={() => getView(item)}
                          >
                            <img src={editIcon} className="edit-btn" />
                          </button>
                          <button
                            className="btn-danger"
                            onClick={() => deleteApi(item?.id)}
                          >
                            <MdOutlineDeleteForever />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="page-inner-cont py-2 d-flex justify-content-end">
            <ReactPaginate
              nextLabel="››"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={overAllCount}
              previousLabel="‹‹"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>

      <Modal
        show={modal}
        onHide={() => {
          closePopup();
        }}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-3">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                {update?.id ? "Edit" : "Add"} Tip
              </label>
              <button className="cust-btn" onClick={() => setModal(false)}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row className="p-4">
            <div className="col-md-12">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                Tip Amount
              </label>
              <div>
                <div className="form-group">
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setTipsAmount(e.target.value)}
                    value={tipsAmount}
                    type={"number"}
                  />
                </div>
                {tipsAmount?.length == 0 && tipsAmountErr && (
                  <p className="err">Enter Tip Amount</p>
                )}
              </div>
            </div>
          </Row>
          <div className="text-center mb-3 mt-3">
            <button
              className={`submit-btn f2 mx-4 ${btn ? "opacity-50" : ""}`}
              onClick={() => submitHandler()}
              disabled={btn}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default TipsList;
